const items = [
  {
    href: '/pld/analysis/black_list',
    title: 'Búsquedas individuales',
  },
  {
    href: '/pld/analysis/risk_matrix',
    title: 'Matriz de riesgo',
  },
];

export default items;
